// src/lib/training.ts
import { getSupabase, currentUser } from "@/lib/supabase";

export interface TrainingLog {
  id: string;
  source: string | null;
  activity_type: string | null;
  avg_heart_rate: number | null;
  max_heart_rate: number | null;
  calories_burned: number | null;
  device_model: string | null;
  created_at: string;
  start_time: string | null;
  data_json: Record<string, unknown> | null;
}

/**
 * Load the most recent training sessions
 */
export async function loadRecentTraining(limit = 30): Promise<TrainingLog[]> {
  const supa = getSupabase();
  const u = await currentUser();
  
  if (!u) {
    console.warn("[training] No authenticated user found");
    return [];
  }

  const { data, error } = await supa
    .from("training_log")
    .select(`
      id,
      source,
      activity_type,
      avg_heart_rate,
      max_heart_rate,
      calories_burned,
      device_model,
      created_at,
      start_time,
      data_json
    `)
    .eq("user_id", u.id)
    .order("created_at", { ascending: false })
    .limit(limit);

  if (error) {
    console.error("[training] Error loading training logs:", error.message);
    return [];
  }

  console.log(`[training] Loaded ${data?.length || 0} training logs`);
  return data ?? [];
}
